import MadeWithYola from './made-with-yola';
import Navbar from './navbar';
import LanguageSelector from './language-selector';
import DifmPromoBanner from './difm-promo-banner';

export default {
  MadeWithYola,
  Navbar,
  LanguageSelector,
  DifmPromoBanner,
};
